import fetchServer from "../../fetchServer";

export async function changeAdminCustomKeyStatus(accountId, data) {
  let result = {
    return: 0,
    msg: "Something went wrong changing admin custom key status!",
  };

  await fetchServer({
    method: "POST",
    // url: `/product/v1/customKey/${accountId}/changeStatus`,
    url: `/product/v1/adminCustomKey/${accountId}/changeStatus`,
    data,
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = { return: 1, msg: "Successful", data: res?.data?.data };
      } else if (res?.data?.error) result["msg"] = res.data.error;
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}
